import './ScrollingText.css'
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import {useCallback} from "react";

export default function ScrollingText({children, className, width = '100%'} : {
    children: ReactNode,
    className?: string,
    width?: string
}) {
    const targetRef = useRef<HTMLDivElement>(null);
    const [scrollSpeed, setScrollSpeed] = useState(0);
    const calculateScrollingText = useCallback(() => {
        const node = targetRef.current;
        if(!node) {
            return;
        }

        let contentWidth = node.scrollWidth;
        if (node.classList.contains("scrollingWrapperDiv")) {
            const textCopy = node.querySelector(".textCopy") as HTMLSpanElement;
            contentWidth = textCopy!.offsetWidth;
        }
        setScrollSpeed(contentWidth > node.clientWidth ? contentWidth * 0.03 : 0)
    }, []);
    const resizeObserver = useMemo(() => new ResizeObserver(calculateScrollingText), []);
    const fillerSpanStyle = {
        display: 'inline-block',
        width: '2em'
    }

    useEffect(() => {
        calculateScrollingText();
    }, [children]);
    useEffect(() => {
        if(targetRef.current) {
            resizeObserver.observe(targetRef.current);

            return () => resizeObserver.disconnect();
        }
    }, [scrollSpeed]);

    return scrollSpeed ? <div style={{width: width}} className="scrollingWrapperDiv" ref={targetRef}>
        <span
            style={{animation: `textScroll ${scrollSpeed}s linear infinite`}}
            className={`scrollingSpan ${className === undefined ? "" : className}`}>
            <span className={"textCopy"}>{children}</span><span style={fillerSpanStyle} />{children}<span style={fillerSpanStyle} />
        </span>
    </div> : <span
        style={{width: width, overflow: 'hidden'}}
        ref={targetRef}
        className={`scrollingSpan ${className === undefined ? "" : className}`}>
        {children}
      </span>
}
